import { useQuery } from '@tanstack/react-query';
import { getOrderEditModes } from '@/api/orders.js';

export const QueryKeys = {
  GetOrderEditModes: orderId => ['order-edit-modes', orderId],
};

export default function useOrderEditModes(orderId) {
  const {
    data: orderEditModes,
    isLoading: orderEditModesLoading,
    error: orderEditModesError,
  } = useQuery({
    queryKey: QueryKeys.GetOrderEditModes(orderId),
    queryFn: async () => {
      return getOrderEditModes(orderId);
    },
    enabled: !!orderId,
  });

  return { orderEditModes, orderEditModesLoading, orderEditModesError };
}
